interface RoutePattern {
  pattern: string | RegExp;
  title: string;
}

export const routePatterns: RoutePattern[] = [
  { pattern: '/', title: 'Home' },
  { pattern: '/profile.html', title: 'Profile' },
  { pattern: '/results.html', title: 'Test Results' },
  { pattern: '/orders.html', title: 'Orders' },
  { pattern: /^\/report\/[\w-]+$/, title: 'Report Details' },
  { pattern: '/pfas-info.html', title: 'PFAS Information' },
  { pattern: '/users/delete.html', title: 'Delete User' },
  { pattern: '/users/edit.html', title: 'Edit Profile' },
  { pattern: '/inbox.html', title: 'Inbox Messages' },
  { pattern: '/tos.html', title: 'Terms of Service' },
  { pattern: '/privacy-policy.html', title: 'Privacy Policy' },
  { pattern: '/order.html', title: 'Order Checkout' },
  { pattern: /^\/orders\/[\w-]+$/, title: 'Order Details' },
  { pattern: /^\/guest-orders\/[\w-]+$/, title: 'Guest Order Details' },
  { pattern: '/signup', title: 'Sign Up' },
  { pattern: '/login', title: 'Login' },
  { pattern: '/forgot-password', title: 'Forgot Password' },
  { pattern: '/reset-password-confirmation', title: 'Reset Password Confirmation' },
  { pattern: '/activate.html', title: 'Activate Account' },
  { pattern: '/guest-activate.html', title: 'Guest Activation' },
  { pattern: /^\/post-activation\/[\w-]+$/, title: 'Post Activation' },
  { pattern: '/support.html', title: 'Support' },
  { pattern: /^\/o\/?$/, title: 'Organizations' },
  { pattern: /^\/o\/[\w-]+\/?$/, title: 'Organization Details' },
  { pattern: /^\/o\/[\w-]+\/edit\/?$/, title: 'Edit Organization' },
  { pattern: /^\/o\/[\w-]+\/orders\/?$/, title: 'Organization Orders' },
  { pattern: /^\/o\/[\w-]+\/orders\/[\w-]+\/?$/, title: 'Organization Order Details' },
  { pattern: /^\/o\/[\w-]+\/a\/?$/, title: 'Accounts' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/?$/, title: 'Account Details' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/staff\/?$/, title: 'Account Staff' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/events\/?$/, title: 'Account Events' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/events\/new\/?$/, title: 'New Account Event' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/events\/[\w-]+\/edit\/?$/, title: 'Edit Account Event' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/events\/[\w-]+\/?$/, title: 'Account Event Details' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/p\/[\w-]+\/?$/, title: 'Patient Details' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/p\/[\w-]+\/q\/[\w-]+\/?$/, title: 'Patient Questionnaire' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/locations\/?$/, title: 'Account Locations' },
  { pattern: /^\/o\/[\w-]+\/a\/[\w-]+\/locations\/[\w-]+\/?$/, title: 'Account Location Details' },
  { pattern: /^\/o\/[\w-]+\/staff\/?$/, title: 'Organization Staff' },
];
